import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { journal } from "@/data/site";

const EASE = [0.22, 1, 0.36, 1];

export default function JournalTeaser() {
    return (
        <section
            data-testid="journal-teaser-section"
            className="relative bg-forest-950 text-ivory py-24 md:py-40"
        >
            <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 items-end mb-14 md:mb-20 gap-8">
                    <div className="md:col-span-8">
                        <div className="flex items-center gap-4 mb-6">
                            <span className="h-px w-10 bg-lime" />
                            <span className="font-mono-mini text-[10px] tracking-[0.42em] uppercase text-lime">
                                The KLiving journal
                            </span>
                        </div>
                        <h2 className="font-serif-display text-4xl md:text-6xl leading-[0.94] tracking-tight max-w-[15ch]">
                            Long-form notes on <em className="not-italic italic text-lime">building well.</em>
                        </h2>
                    </div>
                    <div className="md:col-span-4 md:text-right">
                        <Link
                            to="/journal"
                            data-testid="journal-view-all"
                            className="inline-flex items-center gap-3 font-mono-mini text-[11px] tracking-[0.32em] uppercase text-ivory hover-underline hover:text-lime transition-colors"
                        >
                            All entries
                            <ArrowUpRight size={16} />
                        </Link>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
                    {journal.map((j, i) => (
                        <motion.article
                            key={j.slug}
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-10% 0px" }}
                            transition={{ duration: 0.95, ease: EASE, delay: i * 0.06 }}
                            data-testid={`journal-card-${j.slug}`}
                            className="group"
                        >
                            <Link to={`/journal/${j.slug}`}>
                                <div className="relative overflow-hidden aspect-[4/5]">
                                    <img
                                        src={j.cover}
                                        alt={j.title}
                                        loading="lazy"
                                        className="h-full w-full object-cover transition-transform duration-[1.5s] group-hover:scale-105"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-b from-transparent to-forest-900/70" />
                                    <div className="absolute top-5 left-5 font-mono-mini text-[10px] tracking-[0.32em] uppercase text-ivory/90">
                                        Chapter {j.chapter}
                                    </div>
                                </div>
                                <div className="mt-6 flex items-center gap-3 font-mono-mini text-[10px] tracking-[0.28em] uppercase text-ivory/50">
                                    <span>{j.date}</span>
                                    <span>·</span>
                                    <span>{j.readTime}</span>
                                </div>
                                <h3 className="mt-3 font-serif-display text-2xl md:text-[1.7rem] leading-tight text-ivory group-hover:text-lime transition-colors">
                                    {j.title}
                                </h3>
                            </Link>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
